import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";

export class EntrepreneurController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	getEmployeeById = this.api.own.counterpartyEntrepreneurEmployeeDetailByEmployeeId;
}
